module.exports = __webpack_public_path__ + "img/收货.29179647.svg";